export default __webpack_public_path__ + "static/11_34-5e340c4c93759f71300477eaed9425c7.png";